import { sort_out_arguments } from './findPhoneNumbers';
import PhoneNumberMatcher from './PhoneNumberMatcher';

export default function findNumbers(arg_1, arg_2, arg_3, arg_4) {
	var _sort_out_arguments = sort_out_arguments(arg_1, arg_2, arg_3, arg_4),
	    text = _sort_out_arguments.text,
	    options = _sort_out_arguments.options,
	    metadata = _sort_out_arguments.metadata;

	var matcher = new PhoneNumberMatcher(text, options, metadata);

	var results = [];
	while (matcher.hasNext()) {
		results.push(matcher.next());
	}
	return results;
}
//# sourceMappingURL=findNumbers.js.map